
import { defineComponent } from "vue";
import { Flag, Anchor, Wrench, ArrowLeft } from "lucide-vue-next";

import { createGame, createDebugGame } from "@/api/actions";
import ScreenTitle from "@/components/Elements/ScreenTitle.vue";

export default defineComponent({
  components: { Flag, Anchor, Wrench, ArrowLeft, ScreenTitle },
  data: () => ({ joiningGame: false, joiningGameId: "" }),
  methods: {
    async createGame() {
      const gameId = await createGame();
      this.$router.push({ name: "game", params: { gameId } });
    },
    async createDebugGame() {
      const gameId = await createDebugGame();
      this.$router.push({ name: "game", params: { gameId } });
    },
    joinGame() {
      this.$router.push({
        name: "game",
        params: { gameId: this.joiningGameId },
      });
    },
  },
});
